import * as Sentry from "@sentry/browser";
export { captureException } from "@sentry/browser";

export function initSentry() {
  // Skip Sentry inside automated browsers (Ferrum/Selenium system specs set
  // navigator.webdriver). Sentry's console instrumentation wraps console.error,
  // and inside the headless test browser that wrapper collides with the driver's
  // own console capture and recurses, throwing "Maximum call stack size exceeded"
  // on every page that emits a console error. Sentry has no value in test runs.
  if (navigator.webdriver) {
    return;
  }

  // Each esbuild entrypoint ships its own Sentry copy and calls initSentry(), so
  // a page that loads more than one bundle would wrap console.error repeatedly.
  // Guard at the window level so the console is only ever instrumented once.
  if (window.__sentryInitialized) {
    return;
  }
  window.__sentryInitialized = true;

  // 1) Define a check for whether this is a "production" hostname
  const isProductionHostname = (
    window.location.hostname === "pflege-helfer24.de" ||
    window.location.hostname === "vergleich.pflege-helfer24.de"
  );

  Sentry.init({
    dsn: "https://81cd4bde10fbb15a5e984048fe98144f@o4506593267679232.ingest.us.sentry.io/4507233041317888",

    // Use hostname check to set Sentry environment
    environment: isProductionHostname ? "production" : "development",

    // Performance / Tracing
    integrations: [Sentry.browserTracingIntegration()],

    // Lower performance sample rate if needed
    tracesSampleRate: 0.025, // 2.5%

    // Only propagate tracing headers to same-origin requests. Using anchored
    // regexes (not substring strings) avoids injecting sentry-trace into
    // cross-origin URLs that happen to contain our domain in a query param.
    tracePropagationTargets: [
      /^\//,
      /^https:\/\/(?:[\w-]+\.)?pflege-helfer24\.de\//,
    ],

    // Deny URLs from browser extensions or internal chrome URLs
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
    ],

    // Drop high-volume, non-actionable noise. The getComputedStyle TypeErrors
    // (~15k events/mo) come from extensions/third-party scripts calling it with
    // a non-Element and arrive with empty stack frames, so denyUrls can't catch
    // them. One regex covers both browser wordings ("must be an instance of
    // Element" / "parameter 1 is not of type 'Element'").
    ignoreErrors: [/getComputedStyle/i],

    beforeSend: function (event, hint) {
      // 2) If hostname is not the production domain(s), skip the event
      if (!isProductionHostname) {
        return null;
      }

      // 3) Filter out known bot user agents
      const ua = navigator.userAgent;
      if (/bot|spider|crawler|crawl|Googlebot/i.test(ua)) {
        return null;
      }

      // Otherwise, keep the event
      return event;
    },
  });

  // Temporarily disable Replay to fix "PR is not a function" error
  // Lazy-load Replay if you want session replays
  // import("@sentry/browser").then((lazyLoadedSentry) => {
  //   Sentry.addIntegration(
  //     lazyLoadedSentry.replayIntegration({
  //       maskAllText: false,
  //       blockAllMedia: false,
  //     })
  //   );
  // });
}
